import { useState, useEffect } from "react";
import { C } from "../../constants/theme";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { getUser } from "../../utils/sessao";
import { listaMaquininhas, taxaMaquininha, calcularRepasse, MAX_PARCELAS } from "../../constants/maquininhas";

/* Repassa a taxa da maquininha pro valor calculado — mesma lógica do PDV
   (Caixa), só que aqui a "venda" é o preço final calculado, não um
   carrinho. Fica fechado por padrão (não busca config à toa); ao abrir,
   carrega a config de pagamento do vendedor uma única vez. Botão de linha
   (vive dentro da gaveta de categorias) que abre um popup, igual às
   outras categorias. */
export function CalcularCartao({ valor, compacto = false }) {
  const [aberto, setAberto] = useState(false);
  const [paymentConfig, setPaymentConfig] = useState(null);
  const [maquininhaId, setMaquininhaId] = useState("");
  const [formaCartao, setFormaCartao] = useState("credito"); // 'debito'|'credito'
  const [parcelas, setParcelas] = useState(1);

  useEffect(() => {
    if (!aberto || paymentConfig !== null) return;
    const user = getUser();
    if (!user?.uid) return;
    getDoc(doc(db, "users", user.uid)).then(snap => {
      const cfg = snap.exists() ? (snap.data()?.paymentConfig || null) : null;
      setPaymentConfig(cfg);
      setMaquininhaId(cfg?.maquininhaPadraoId || listaMaquininhas(cfg)[0]?.id || "");
    }).catch(() => {});
  }, [aberto, paymentConfig]);

  const maquininhas = listaMaquininhas(paymentConfig);
  const maquininhaAtual = maquininhas.find(m => m.id === maquininhaId) || maquininhas[0];
  const taxaPct = taxaMaquininha(maquininhaAtual, formaCartao === "debito" ? "debito" : parcelas);
  const { acrescimo, valorCobrar } = calcularRepasse(valor, taxaPct);

  return (
    <>
      {compacto ? <button type="button" className="calc-simulation-link" onClick={() => setAberto(true)}>Cartão</button> : (
<button onClick={() => setAberto(true)}
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", background: "none", border: "none", borderBottom: "1px solid rgba(255,255,255,0.06)", padding: "11px 2px", cursor: "pointer", textAlign: "left" }}>
        <span style={{ fontSize: 12.5, fontWeight: 600, color: C.text, display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 13, opacity: .8 }}>💳</span>Cartão
        </span>
        <span style={{ color: C.muted, fontSize: 12 }}>›</span>
      </button>
)}

      {aberto && (
        <>
          <div onClick={() => setAberto(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", zIndex: 1000 }} />
          <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: "min(420px,94vw)", maxHeight: "85vh", overflowY: "auto", background: C.panel, border: "1px solid #009ee344", borderRadius: 18, padding: 20, zIndex: 1001, boxShadow: "0 24px 64px rgba(0,0,0,0.7)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <span style={{ color: "#009ee3", fontWeight: 900, fontSize: 14, letterSpacing: 1 }}>💳 CALCULAR PRA CARTÃO</span>
              <button onClick={() => setAberto(false)} style={{ background: "none", border: "none", color: C.muted, cursor: "pointer", fontSize: 20, lineHeight: 1 }}>✕</button>
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
              <select value={maquininhaId} onChange={e => setMaquininhaId(e.target.value)}
                style={{ flex: "1 1 120px", padding: "7px 8px", background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, fontSize: 12, outline: "none" }}>
                {maquininhas.map(m => <option key={m.id} value={m.id}>{m.nome || "Maquininha"}</option>)}
              </select>
              <div style={{ display: "flex", gap: 4 }}>
                {[["debito", "Débito"], ["credito", "Crédito"]].map(([v, l]) => (
                  <button key={v} onClick={() => setFormaCartao(v)}
                    style={{ padding: "7px 10px", borderRadius: 8, fontSize: 11, fontWeight: 700, cursor: "pointer",
                      background: formaCartao === v ? "rgba(0,158,227,0.15)" : "transparent",
                      border: "1px solid " + (formaCartao === v ? "#009ee3" : C.border),
                      color: formaCartao === v ? "#009ee3" : C.muted }}>
                    {l}
                  </button>
                ))}
              </div>
              {formaCartao === "credito" && (
                <select value={parcelas} onChange={e => setParcelas(Number(e.target.value))}
                  style={{ padding: "7px 8px", background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, fontSize: 12, outline: "none" }}>
                  {Array.from({ length: MAX_PARCELAS }, (_, i) => i + 1).map(n => <option key={n} value={n}>{n}x</option>)}
                </select>
              )}
            </div>
            {!maquininhaAtual ? (
              <div style={{ fontSize: 11, color: C.muted }}>Cadastre uma maquininha em Configurações → Pagamentos.</div>
            ) : (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: C.muted, marginBottom: 4 }}>
                  <span>+ Taxa ({taxaPct.toFixed(2)}%{formaCartao === "credito" ? ` · ${parcelas}x` : ""})</span><span style={{ color: "#f59e0b" }}>+R$ {acrescimo.toFixed(2)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, fontWeight: 900, color: C.text, borderTop: "1px solid " + C.border, paddingTop: 6 }}>
                  <span>Cobrar no cartão</span><span style={{ color: C.success }}>R$ {valorCobrar.toFixed(2)}</span>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
}
